import React, { useCallback, useState } from 'react'
import clsx from 'clsx'
import { bindActionCreators, Dispatch } from 'redux'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'
import { useLocation, Location } from 'react-router-dom'
import Button from 'components/Button'
import Typography from 'components/Typography'
import { useBreakpoint } from 'utils/Hooks'
import Dialog from 'components/Dialog'
import TextField from 'components/TextField'
import { copyToClipboard } from 'utils/Clipboard'
import Snackbar from 'components/Snackbar'
import { dialogSelectors, DialogNames, dialogActions } from 'duck/DialogDuck'
import { RootState, RootActionType } from 'duck'
import stylesGlobal from 'stylesGlobal.module.scss'

const utils = {
  getShareUrl: (location: Location) => {
    const params = location.pathname.split('/', 3)

    return window.location.origin + `/${params[1]}/${params[2]}`
  }
}

const classesInput = {
  input: stylesGlobal.Truncate
}

const mapStateToProps = (state: RootState) => ({
  activeDialog: dialogSelectors.activeDialog(state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      closeDialog: dialogActions.closeDialog
    },
    dispatch
  )

type DialogShareUrlProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const DialogShareUrl: React.FC<DialogShareUrlProps> = props => {
  const { activeDialog, closeDialog } = props

  const { isSmallscreenAbove } = useBreakpoint()
  const location = useLocation()
  const [openSnackbarCopy, setOpenSnackbarCopy] = useState(false)
  const open = activeDialog === DialogNames.PROJECT_COPYURL

  const handleCloseDialogCopy = useCallback(() => {
    closeDialog()
  }, [closeDialog])

  const shareUrl = utils.getShareUrl(location)

  return (
    <>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={handleCloseDialogCopy}
        onBackdropClick={handleCloseDialogCopy}
        fullWidth
      >
        <div
          className={clsx(
            stylesGlobal.PaddingTop12,
            stylesGlobal.PaddingBottom64,
            stylesGlobal.PaddingX60
          )}
        >
          <Typography
            className={stylesGlobal.MarginBottom16}
            variant="h5"
            align="center"
            fontWeight="bold"
          >
            Share
          </Typography>

          <Grid container>
            <Grid
              className={clsx(
                stylesGlobal.Width1,
                isSmallscreenAbove && stylesGlobal.PaddingRight12
              )}
              xs={12}
              sm
              item
            >
              <TextField
                size="small"
                placeholder="Enter Email"
                InputProps={{
                  className: !isSmallscreenAbove ? stylesGlobal.BorderRoundedBNone : undefined,
                  classes: classesInput,
                  readOnly: true
                }}
                value={shareUrl}
                fullWidth
              />
            </Grid>

            <Grid xs={12} sm="auto" item>
              <Button
                className={!isSmallscreenAbove ? stylesGlobal.BorderRoundedTNone : undefined}
                color="secondary"
                variant="contained"
                fullWidth={!isSmallscreenAbove}
                onClick={() => {
                  copyToClipboard(shareUrl)
                  setOpenSnackbarCopy(true)
                }}
              >
                Copy
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>

      <Snackbar
        open={openSnackbarCopy}
        message="Copied"
        onClose={() => {
          setOpenSnackbarCopy(false)
        }}
      />
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogShareUrl)
